/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Grid,
  FormControlLabel,
  Checkbox,
  Paper,
  Box,
  Button,
  Typography,
} from '@material-ui/core';
import { ExpandMore, Description } from '@material-ui/icons';
import { SortableElement } from 'react-sortable-hoc';
import TextEditor from '../TextEditor';
import { useBlocks } from '../../hooks/context/useBlocks.hook';
import { SelectBrandProduct } from './SelectBrandProduct';
import useStyles from './styles';

const AccordionItem = SortableElement(
  ({
    block,
    onSelectItem,
    mainBlock,
    setContent,
    content,
    idx,
    setBlockSubTitle,
    saveBlocks,
    deleteBlock,
    discardUnsavedBlock,
  }) => {
    const {
      siteDomain,
      dynamicFieldsList,
      dynamicFieldsPermission,
      setBlocks,
    } = useBlocks();

    const [contentBlock, setContentBlock] = useState(content);
    const [contentTitle, setContentTitle] = useState(block.subtitle);
    const [errorTitle, setErrorTitle] = useState(false);
    const [errorContent, setErrorContent] = useState(false);
    const [lastBlockContent, setLastBlocktContent] = useState(block.content);
    const [autosaveLoading, setAutosaveLoading] = useState(false);
    const [autosaveLoadingText, setAutosaveLoadingText] = useState('');
    const [brandId, setBrandId] = useState(block.brandId);
    const [productId, setProductId] = useState(block.productId);

    const AUTOSAVE_INTERVAL = 2000;

    const [contentIndex] = useState(idx);
    const classes = useStyles();

    useEffect(() => {
      if (mainBlock) {
        setContent(contentBlock);
      } else {
        setContent(contentIndex, contentBlock);
      }
      if (contentBlock && contentBlock.length > 0) {
        setErrorContent(false);
      }
    }, [contentBlock, contentIndex]);

    const handleChange = (e) => {
      setContentTitle(e.target.value);
      setBlockSubTitle(contentIndex, e.target.value);
    };

    const changeWordCount = () => {};
    const checkEmptyFields = () => {
      let error = false;
      if (contentTitle === '') {
        setErrorTitle(true);
        error = true;
      } else {
        setErrorTitle(false);
      }
      if (contentBlock === '') {
        setErrorContent(true);
        error = true;
      } else {
        setErrorContent(false);
      }
      return error;
    };

    const saveContentBlock = async (arrBlocks, autosave = false) => {
      if (!checkEmptyFields()) {
        await saveBlocks(arrBlocks, !autosave);
      }
      setAutosaveLoadingText('💾 saved ✔');
    };

    useEffect(() => {
      const timer = setTimeout(() => {
        if (
          lastBlockContent !== undefined &&
          lastBlockContent !== contentBlock &&
          contentBlock !== '' &&
          contentBlock !== null
        ) {
          setAutosaveLoading(true);
          setAutosaveLoadingText('⏳ saving...');
          saveContentBlock([block], true);
          setLastBlocktContent(contentBlock);
        }
      }, AUTOSAVE_INTERVAL);
      return () => clearTimeout(timer);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [block, contentBlock]);

    useEffect(() => {
      if (block) {
        if (mainBlock) {
          block.productId = productId;
        } else {
          setBlocks((blocks) => {
            const updatedBlocks = [...blocks];
            updatedBlocks[idx] = { ...updatedBlocks[idx], productId };
            return updatedBlocks;
          });
        }
      }
    }, [productId]);

    useEffect(() => {
      if (mainBlock) {
        block.brandId = brandId;
      } else {
        setBlocks((blocks) => {
          const updatedBlocks = [...blocks];
          updatedBlocks[idx].brandId = brandId;
          return updatedBlocks;
        });
      }
    }, [brandId]);

    return (
      <Accordion index={`block-${block.id}`} defaultExpanded={mainBlock}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls={`panel${block.id}-content`}
          id={`panel${block.id}-content`}
        >
          {mainBlock ? (
            <Box className={classes.mainBlockHeader}>
              <Description />
              <p className={classes.spaceIconText}>CONTENT</p>
            </Box>
          ) : (
            <FormControlLabel
              control={
                <Checkbox
                  onClick={(e) => onSelectItem(e, block)}
                  disabled={!block.id}
                />
              }
              onFocus={(event) => event.stopPropagation()}
              label={contentTitle}
            />
          )}
        </AccordionSummary>
        <AccordionDetails className={classes.accordionBackground}>
          <Grid container>
            <Paper elevation={3} className={classes.wrapper}>
              {autosaveLoading && (
                <Typography
                  variant="p"
                  component="p"
                  className={classes.autosaveLoading}
                >
                  {autosaveLoadingText}
                </Typography>
              )}
              {!mainBlock && (
                <>
                  <Box display="flex" p={1}>
                    <Box flexGrow={1}>
                      <TextField
                        xs={6}
                        autoFocus
                        error={errorTitle}
                        label="Block title"
                        value={contentTitle}
                        color="primary"
                        onChange={(e) => handleChange(e)}
                        fullWidth
                      />
                    </Box>
                    <Box m={1}>
                      <Button
                        xs={3}
                        onClick={() => saveContentBlock([block])}
                        size="small"
                        variant="contained"
                        color="primary"
                      >
                        Save
                      </Button>
                    </Box>
                    <Box m={1}>
                      {block.id && (
                        <Button
                          xs={3}
                          onClick={() => deleteBlock(block.id)}
                          size="small"
                          variant="outlined"
                          color="primary"
                        >
                          Delete
                        </Button>
                      )}
                      {!block.id && (
                        <Button
                          xs={3}
                          onClick={() => discardUnsavedBlock(idx)}
                          size="small"
                          variant="outlined"
                          color="primary"
                        >
                          Discard
                        </Button>
                      )}
                    </Box>
                  </Box>
                  <SelectBrandProduct
                    brandId={brandId}
                    setBrandId={setBrandId}
                    productId={productId}
                    setProductId={setProductId}
                  />
                </>
              )}
              <Grid item xs={12} className={classes.inputField}>
                <TextEditor
                  content={contentBlock}
                  setContent={setContentBlock}
                  errorContent={errorContent}
                  siteDomain={siteDomain}
                  dynamicFieldsList={dynamicFieldsList}
                  showDynamicFields={dynamicFieldsPermission}
                  onWordCountChanged={changeWordCount}
                />
              </Grid>
            </Paper>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  },
);

export default React.memo(AccordionItem);
